export default function getWeatherURL(
  latitude: number,
  longitude: number
): string {
  return `https://weathernews.jp/onebox/${latitude}/${longitude}/`;
}
